import React, { FC, useCallback } from 'react'
import isEmpty from 'lodash/isEmpty'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { getBillingProInfo } from 'common/billing/entities/pro/selectors'
import { getIsCancellationModalOpen } from 'common/billing/entities/subscription/selectors'
import { cancellationActions } from 'common/billing/redux/cancellation'

import { CancelSubscriptionModal } from './CancelSubscriptionModal'

/**
 * The only mount point of `CancelSubscriptionModal`. Driven by the cancellation slice: every entry
 * point dispatches `startCancelSubscription()`, which also lazily fetches the reasons list.
 */
export const CancelSubscriptionModalHost: FC = () => {
  const dispatch = useAppDispatch()
  const { cancellationReasonsList: reasons = [], fetchingCancelReasons } =
    useAppSelector(getBillingProInfo)
  const isOpen = useAppSelector(getIsCancellationModalOpen)

  const onClose = useCallback(() => {
    dispatch(cancellationActions.close())
  }, [dispatch])

  if (!isOpen || isEmpty(reasons) || fetchingCancelReasons) return null

  return <CancelSubscriptionModal isOpen onClose={onClose} />
}
